import React from 'react';

const FIELDS = [
  { id: 'smoking', label: 'Smoking', type: 'select', options: ['Never', 'Former', 'Current'] },
  { id: 'alcohol', label: 'Alcohol', type: 'select', options: ['None', 'Occasional', 'Regular'] },
  { id: 'exercise', label: 'Physical activity', type: 'select', options: ['Sedentary', 'Moderate', 'Active'] },
  { id: 'sleep', label: 'Sleep (hrs/night)', type: 'number' },
  { id: 'stress', label: 'Stress level', type: 'select', options: ['Low', 'Moderate', 'High'] },
  { id: 'diet', label: 'Diet pattern', type: 'text' },
  { id: 'phq2', label: 'PHQ-2 score (0–6)', type: 'number' },
  { id: 'fallRisk', label: 'Fall risk', type: 'select', options: ['Low', 'Medium', 'High'] },
];

/** Structured health / lifestyle assessment */
export default function HealthAssessmentPanel({ value = {}, onChange, readOnly }) {
  const set = (k, v) => onChange?.({ ...value, [k]: v });

  return (
    <div className="card" style={{ marginTop: 12, borderLeft: '4px solid #10b981' }}>
      <h4 style={{ margin: '0 0 12px', color: '#059669' }}>Health assessment</h4>
      <div className="form-grid">
        {FIELDS.map((f) => (
          <div key={f.id} className="field">
            <label>{f.label}</label>
            {f.type === 'select' ? (
              <select className="input" value={value[f.id] || ''} disabled={readOnly} onChange={(e) => set(f.id, e.target.value)}>
                <option value="">—</option>
                {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            ) : (
              <input className="input" type={f.type} value={value[f.id] || ''} readOnly={readOnly} onChange={(e) => set(f.id, e.target.value)} />
            )}
          </div>
        ))}
        <div className="field full">
          <label>Summary / plan</label>
          <textarea className="input" rows={2} value={value.summary || ''} readOnly={readOnly} onChange={(e) => set('summary', e.target.value)} placeholder="Lifestyle counselling, referrals…" />
        </div>
      </div>
    </div>
  );
}
